<template>
  <el-dialog
    title="操作日志"
    :visible.sync="isShowDialog"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="log-list">
      <el-table v-loading="loading" :data="logList">
        <el-table-column type="index" width="55" align="center" label="序号" />
        <el-table-column label="操作类型" align="center" prop="operateType">
          <template slot-scope="scope">
            <span>{{ typeFilter(scope.row.operateType) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作内容"
          align="center"
          :show-overflow-tooltip="true"
          prop="operateContent"
          width="255"
        >
          <template slot-scope="scope">
            <span>{{ operateContent(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作描述"
          align="center"
          :show-overflow-tooltip="true"
          prop="operateDesc"
        >
        </el-table-column>
        <el-table-column
          label="操作人"
          align="center"
          prop="operateByName"
          show-overflow-tooltip
        />
        <el-table-column label="操作时间" align="center" prop="operateTime">
          <!--          <template slot-scope="scope">-->
          <!--            <span>{{ parseTime(scope.row.operateTime) }}</span>-->
          <!--          </template>-->
        </el-table-column>
      </el-table>

      <pagination
        v-show="page.total > 0"
        :total="page.total"
        :page.sync="page.pageNum"
        :limit.sync="page.pageSize"
        @pagination="getList"
      />
    </div>
  </el-dialog>
</template>

<script>
// import { list } from "@/api/business/log/api_log";

export default {
  name: "index",
  dicts: ["operate_type"],
  props: {
    queryParams: {
      type: Object,
      default: () => ({
        businessId: "",
        tableName: "",
        operateType: "",
      }),
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      isShowDialog: false,
      logList: [],
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  methods: {
    open() {
      this.isShowDialog = true;
      // this.getList();
    },
    // async getList() {
    //   this.loading = true;
    //   let res = await list({
    //     ...this.queryParams,
    //     pageNum: this.page.pageNum,
    //     pageSize: this.page.pageSize,
    //   });
    //   this.loading = false;
    //   this.logList = res.rows;
    //   this.page.total = res.total;
    // },
    typeFilter(val) {
      if (val) {
        return this.dict.type.operate_type.find((ele) => ele.value === val)
          .label;
      }
      return "";
    },
    operateContent(row) {
      return (
        "在[" +
        row.businessType +
        "]模块[" +
        this.typeFilter(row.operateType) +
        "][" +
        row.operateContent +
        "]"
      );
    },
  },
};
</script>

<style scoped lang="scss">
.log-list {
  ::v-deep {
    .el-table__header-wrapper {
      border-radius: 6px;
    }
  }
}
</style>
